import { FC, useState } from 'react';
import { Button, Confirm, Icon, Modal, ModalProps } from 'semantic-ui-react';
import Table from './Table';
import {TextCell, ButtonCell} from './Table';
import { IOApiTableActions } from './IOApiTable';
import { envColor } from '../common';

interface Props extends ModalProps {
    file?: { name: string, content: any[] };
    onClose: () => void;
    onFile: (path: string[]) => void;
}


const HistoryWindow: FC<Props> = (props) => {
    const [actions, setActions] = useState<IOApiTableActions>();

    if (props.file === undefined) {
        return <div></div>;
    }

    const { currentApi, file, onClose, onFile, onRestore, ...modalProps } = props;
    const { name, content } = file;

    const restoreFile = async (fileVar: string[]) => {
        const live_ver = fileVar[2]

        if (live_ver){
            window.alert('You cannot upload to live current version!')
            return
        }
        const file_ver = await currentApi.read(fileVar[0], fileVar[1]);
        const { name, content } = file_ver;
        const bytesNums = new Array(content.length);

        for (let i = 0; i < content.length; i++) {
            bytesNums[i] = content.charCodeAt(i);
        }
        const byteArray = new Uint8Array(bytesNums);
        const restoredFile = new Array(new File([byteArray], name));
        onRestore();
        onClose();
        const restoreResults = await currentApi.write(restoredFile);
    };

    return (
        <Modal
            size='large'
            style={{ minWidth: '70%', maxWidth: '95%' }}
            closeIcon
            open={true}
            {...modalProps}
            onClose={onClose}
        >
            <Modal.Header>{name}</Modal.Header>
            <Modal.Content scrolling>

            <Table rows={content}  definition>
                <ButtonCell
                    header=''
                    icon='share'
                    value={x => new Array(x.srckey, x.version_id, x.live)}
                    onClick={restoreFile}
                    color={envColor}
                />
                <ButtonCell
                    header=''
                    icon='arrow down'
                    value={x => new Array(x.srckey, x.version_id)}
                    onClick={onFile}
                    color={envColor}
                />
                <TextCell header='Uploader' value={x => x.author} />
                <TextCell header='Last Updated' value={x => x.last_modified} />
                <TextCell header='Version' value={x => x.version_id} />
            </Table>
            </Modal.Content>
            <Modal.Actions>
                <Button circular onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
  )
}

export default HistoryWindow;